
import React from "react";
import { Container } from "react-bootstrap";
import {useTranslation} from "react-i18next";


const AuthFooter = () => {
    const {t } = useTranslation();
    return (
        <React.Fragment>
            <Container>
                <div className="mt-5 text-center">
                    <p className="mb-0 text-muted">
                        &copy; {new Date().getFullYear()} {t('AuthFooter.title')}. {t('AuthFooter.description')}
                    </p>
                </div>
            </Container>

        </React.Fragment>

    )
}
export default AuthFooter;